export default "__VITE_ASSET__Bp4h$x83__"